import React from 'react';

import { Skinplace } from '@entities/skinplace';

const SkinplacePage = () => {
	return <Skinplace />;
};

export default SkinplacePage;
